<template>
  <v-container style="width: 100vmax; max-width: 2500px; position: relative;" class="justify-center pa-0">
    <v-system-bar window color="#006D94">
      <span>Market Analyzer</span>
      <v-spacer></v-spacer>
      <!--<v-btn icon="mdi-minus" variant="text"></v-btn>-->
      <!--<v-btn icon="mdi-checkbox-blank-outline" variant="text" class="ms-2"></v-btn>-->
      <v-btn icon="mdi-close" variant="text" class="ms-2" @click="close()"></v-btn>
    </v-system-bar>
    <v-progress-linear color="#006D94" height="4" indeterminate rounded v-if="loading"></v-progress-linear>

    <v-btn @click="toggleDrag" v-if="!loading && !error">{{ dragEnabled ? 'Done' : 'Adjust Layout' }}</v-btn>

    <v-container class="ml-0 align-center" fluid style="width: 100%">
      <v-alert v-if="!loading && error" class="mb-2" variant="outlined" type="error" border="top">
        Server Error: Could fetch resources.
      </v-alert>

      <draggable v-model="items" tag="div" class="draggable-container" :move="move" @end="updateCharts"
        :disabled="!dragEnabled">
        <template #item="{ element }">
          <div :id="element.i" :key="element.i" :class="['draggable-item', dragEnabled ? 'striped-overlay' : '']"
            :style="{
              cursor: dragEnabled ? 'move' : 'crosshair',
              resize: dragEnabled ? 'both' : '',
              overflow: dragEnabled ? 'auto' : ''
            }">
          </div>
        </template>
      </draggable>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import enigma from 'enigma.js';
import config from '../config.js';
import draggable from 'vuedraggable';
import sdk from '@qlik/sdk';
import stardust from '@nebula.js/stardust';
import barchart from '@nebula.js/sn-bar-chart';
import linechart from '@nebula.js/sn-line-chart';
import table from '@nebula.js/sn-table';
import comboChart from '@nebula.js/sn-combo-chart';
import map from '@nebula.js/sn-map';
import treemap from '@nebula.js/sn-treemap';
import filterpane from '@nebula.js/sn-filter-pane'

/*const TENANT = config.QLIK_TENANT;
//const JWTENDPOINT = '<RESTful-endpoint-to-retrieve-JWT>';
const WEBINTEGRATIONID = config.QLIK_WEBINTEGRATIONID;
const APPID = config.QLIK_APPID_MARKETANALYZER;
const SHEETID = config.QLIK_SHEETID_MARKETANALYZER;*/

export default {
  components: {
    draggable
  },
  data() {
    return {
      dragEnabled: false,
      drawer: true,
      rail: true,
      loading: true,
      error: false,
      TENANT: config.QLIK_TENANT,
      WEBINTEGRATIONID: config.QLIK_WEBINTEGRATIONID,
      APPID: config.QLIK_APPID_MARKETANALYZER,
      SHEETID: config.QLIK_SHEETID_MARKETANALYZER,
      items: [
        { i: "chart-container-1" },
        { i: "chart-container-2" },
        { i: "chart-container-3" },
      ],
      to_render: [

      ]
    };
  },
  mounted() {
    document.title = 'TIS Market Analyzer'
    this.main();
  },
  methods: {
    close() {
      this.$router.push('/');
    },
    toggleDrag() {
      this.dragEnabled = !this.dragEnabled;
    },
    move(event) {
      if (!this.dragEnabled) {
        return false;
      }
      return true;
    },
    async updateCharts() {
      this.render();
    },
    async qlikLogin() {
      const loggedIn = await this.checkLoggedIn();
      if (loggedIn.status !== 200) {

        const response = await axios.get(`${config.baseURL}/api/v1/qlik_jwt/`);

        const loginRes = await this.jwtLogin(response.data.token);

        if (loginRes.status !== 200) {
          const message = 'Something went wrong while logging in.';
          alert(message);
          throw new Error(message);
        }
        const recheckLoggedIn = await this.checkLoggedIn();
        if (recheckLoggedIn.status !== 200) {
          const message = 'Third-party cookies are not enabled in your browser settings and/or browser mode.';
          alert(message);
          throw new Error(message);
        }
      }
      console.log('Logged in!');
      return true;
    },
    async checkLoggedIn() {
      return await fetch(`https://${this.TENANT}/api/v1/users/me`, {
        mode: 'cors',
        credentials: 'include',
        headers: {
          'qlik-web-integration-id': this.WEBINTEGRATIONID,
        },
      });
    },
    async jwtLogin(token) {
      const authHeader = `Bearer ${token}`;
      return await fetch(`https://${this.TENANT}/login/jwt-session?qlik-web-integration-id=${this.WEBINTEGRATIONID}`, {
        credentials: 'include',
        mode: 'cors',
        method: 'POST',
        headers: {
          Authorization: authHeader,
          'qlik-web-integration-id': this.WEBINTEGRATIONID,
        },
      });
    },
    async getQCSHeaders() {
      const response = await fetch(`https://${this.TENANT}/api/v1/csrf-token`, {
        mode: 'cors',
        credentials: 'include',
        headers: {
          'qlik-web-integration-id': this.WEBINTEGRATIONID,
        },
      });

      const csrfToken = new Map(response.headers).get('qlik-csrf-token');
      return {
        'qlik-web-integration-id': this.WEBINTEGRATIONID,
        'qlik-csrf-token': csrfToken,
      };
    },
    async render() {
      this.items.forEach(item => {
        const element = document.getElementById(item.i);
        if (element) {
          element.innerHTML = '';
        }
      });

      this.to_render[0].render({
        element: document.getElementById('chart-container-1'),
        id: 'PhvJLZW',
      });

      this.to_render[1].render({
        element: document.getElementById('chart-container-2'),
        id: 'kGVLvFj',
      });

      this.to_render[2].render({
        element: document.getElementById('chart-container-3'),
        id: 'zuDzsk',
      });

      /*this.to_render[3].render({
        element: document.getElementById('chart-container-4'),
        id: 'ptDEpVw',
      });

      this.to_render[4].render({
        element: document.getElementById('listbox-container'),
        type: 'listbox',
        fields: ['Year', 'Month', 'Day', 'Weekday', 'Date', 'Port'],
      });*/
    },
    async main() {
      this.error = false;
      const tenantUri = `https://${config.QLIK_TENANT}`;
      const webIntegrationId = config.QLIK_WEBINTEGRATIONID;

      const request = async (path, returnJson = true) => {
        const res = await fetch(`${tenantUri}${path}`, {
          mode: 'cors',
          credentials: 'include',
          redirect: 'follow',
          headers: {
            'qlik-web-integration-id': webIntegrationId,
          },
        });
        if (res.status < 200 || res.status >= 400) throw res;
        return returnJson ? res.json() : res;
      };

      try {
        const loggedIn = await this.qlikLogin();
        const res = await request('/api/v1/csrf-token', false);
        const csrfToken = res.headers.get('qlik-csrf-token');
        const apps = await request('/api/v1/items?resourceType=app');

        if (!apps.data.length) {
          console.error('No apps available');
          return;
        }

        const appId = apps.data.find(app => app.name === 'Market Analyser')['resourceId'];
        const url = `${tenantUri.replace('https', 'wss')}/app/${appId}?qlik-web-integration-id=${webIntegrationId}&qlik-csrf-token=${csrfToken}`;
        const schema = await (await fetch('https://unpkg.com/enigma.js@2.7.0/schemas/12.612.0.json')).json();

        const session = enigma.create({ url, schema });
        const global = await session.open();
        const app = await global.openDoc(appId);

        const line = stardust.embed(app, {
          types: [
            {
              name: 'linechart',
              load: () => Promise.resolve(linechart),
            },
          ],
        });

        this.to_render.push(line);

        const tbl = stardust.embed(app, {
          types: [
            {
              name: 'table',
              load: () => Promise.resolve(table),
            },
          ],
        });

        this.to_render.push(tbl);

        const bar = stardust.embed(app, {
          types: [
            {
              name: 'barchart',
              load: () => Promise.resolve(barchart),
            },
          ],
        });

        this.to_render.push(bar);

        /*const nebbie = stardust.embed(app, {
          types: [
            {
              name: 'barchart',
              load: () => Promise.resolve(barchart),
            },
          ],
        });

        this.to_render.push(nebbie);

        const map = stardust.embed(app, {
          types: [
            {
              name: 'treemap',
              load: () => Promise.resolve(treemap),
            },
          ],
        });

        this.to_render.push(map);

        const bar2 = stardust.embed(app, {
          types: [
            {
              name: 'barchart',
              load: () => Promise.resolve(bar2),
            },
          ],
        });

        this.to_render.push(bar2);


        const filter = stardust.embed(app, {
          types: [
            {
              name: 'listbox',
              load: () => Promise.resolve(listbox),
            },
          ],
        });

        this.to_render.push(filter);*/

        this.render();


      } catch (err) {
        console.error(err);
        this.error = true;
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
  }
};
</script>

<style scoped>
.container {
  align-items: center;
  justify-content: center;
  text-align: center;
}

.draggable-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.draggable-item {
  width: 500px;
  height: 500px;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.striped-overlay {
  width: 500px;
  /* Breite des divs */
  height: 500px;
  /* Höhe des divs */
  background: linear-gradient(45deg,
      rgba(0, 0, 0, 0.1) 25%,
      transparent 25%,
      transparent 50%,
      rgba(0, 0, 0, 0.1) 50%,
      rgba(0, 0, 0, 0.1) 75%,
      transparent 75%,
      transparent);
  background-size: 40px 40px;
  /* Größe des Musters */
  background-color: rgba(255, 255, 255, 0.15);
  /* Grundfarbe und Transparenz */
}
</style>
